const Util = {
    getAge: (d1, d2) => {
		d1 = d1.getTime() / 31536000000;
		d2 = d2.getTime() / 31536000000;
		return (new Number(d2 - d1).toFixed(0)) + ' Years';
    },

    setHours: (dt, h) => {
        var s = /(\d+):(\d+)(.+)/.exec(h);
        dt.setHours(s[3] === " PM" ? 12 + parseInt(s[1], 10) : parseInt(s[1]), parseInt(s[2]), 0, 0);
        return new Date(dt);
    },

    getFormatDate: (dateObj) => {
        if(dateObj.date != undefined)
        {
            var dateToFormat  = new Date()
            if(dateObj.date != undefined) {
                if(dateObj.appentZ)
                {
                    dateObj.date = dateObj.date +".000Z"
                }
                dateToFormat = new Date(dateObj.date)
            }

            if(dateObj.type == undefined)
                dateObj.type = 'short';

            return  new Intl.DateTimeFormat("en-GB", {
                year: "numeric",
                month: dateObj.type,
                day: "2-digit"
                }).format(dateToFormat);
        }
    },
    
    getDayFullName: (type, day) => {
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const shortDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        
        if(day == undefined)
           day = new Date().getDay();
        
        switch(type)
        {
            case "LONG":
                return days[day];        
            case "SHORT":
                return shortDays[day];
            default:
                return days[day]; 
        }
    },

    startOfWeek: (dateToLoad) => {
        var date = new Date();
        if(dateToLoad != undefined)
            date = new Date(dateToLoad)

        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);
        return new Date(date.setDate(diff));
    },
    
    getDateStringForPost: (date) => {
        return date.toISOString();
        //return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    },

    getTimeEntry: (weekDate) => {
        let date = weekDate.getDate();
        let timeEntry = [];
        let timeStartFrom = 10;
        for (let index = 0; index < 10; index++) {
            var time = Util.apendOnTime(timeStartFrom) + ':00 ' +  (timeStartFrom == 10 || timeStartFrom == 11  ? 'AM' : 'PM');

            timeEntry.push({
                id: weekDate.getDate() + '_'+ (weekDate.getMonth() + 1) + '_' + weekDate.getFullYear() + '_' + time,
                time: time,
                selected: false
            });

            if(timeStartFrom == 12)
                timeStartFrom = 1
            else 
                timeStartFrom++;
        }
        return timeEntry;
    },

    apendOnTime: (time) => {
        return  (time >= 10 ? time : '0'+time)
    },

    getWeekDates: (dateToLoad) => {
        let weekData = [];
        for (let i = 0; i < 7; i++) {
            var date = new Date(Util.startOfWeek(dateToLoad).setDate(Util.startOfWeek(dateToLoad).getDate() + i));
            weekData.push({
                d: date,
                date: Util.getFormatDate({date: date, type: 'short'}),
                day: Util.getDayFullName('SHORT', date.getDay()),
                fullDayName: Util.getDayFullName('LONG', date.getDay()),
                timeEntry: Util.getTimeEntry(date)
            });
        }
        return weekData;
    },

    groupBy: (objectArray, property) => {
        return objectArray.reduce((acc, obj) => {
           const key = obj[property];
           if (!acc[key]) {
              acc[key] = [];
           }
           // Add object to list for given key's value
           acc[key].push(obj);
           return acc;
        }, {});
    },

    getCommaseperatedValue: (objectArray, property) => {
        let returnValue = [];
        if(objectArray != undefined)
            objectArray.forEach(element => {
                for (const [key, value] of Object.entries(element)) {
                    if(key === property)
                    {
                        returnValue.push(value);
                    }
                }
            });
        return returnValue.join();
    },

    diff_minutes: (dt2, dt1) => {
        var diff =(dt2.getTime() - dt1.getTime()) / 1000;
        diff /= 60;
        return Math.abs(Math.round(diff));
    },

    diff_hours: (dt2, dt1) => {
        var diff =(dt2.getTime() - dt1.getTime()) / 1000;
        diff /= 60;
        diff /= 60;
        return Math.abs(Math.round(diff));
    },

    diff_days: (dt2, dt1) => {
        var diff =(dt2.getTime() - dt1.getTime()) / 1000;
        diff /= 60;
        diff /= 60;
        diff /= 24;
        return Math.abs(Math.round(diff));
    },

    diff_months: (dt2, dt1) => {
        var diff =(dt2.getTime() - dt1.getTime()) / 1000;
        diff /= 60;
        diff /= 60;
        diff /= 24;
        diff /= 30;
        return Math.abs(Math.round(diff));
    },

    diff_years: (dt2, dt1) => {
        return  Math.abs(dt2.getFullYear() - dt1.getFullYear());
    },

    getDateDifffromToDay: (date) => {
        var dateToCompare  = new Date(date);
        var currentDate = new Date();
        var minDiff = Util.diff_minutes(currentDate, dateToCompare);
        var hourDiff = Util.diff_hours(currentDate, dateToCompare);
        var dayDiff = Util.diff_days(currentDate, dateToCompare);
        var monthDiff = Util.diff_months(currentDate, dateToCompare);
        var yearDiff = Util.diff_years(currentDate, dateToCompare);

        if(minDiff < 60) {
            return minDiff == 1 ? minDiff + ' minute ago' : minDiff + ' minutes ago';
        } else if(hourDiff < 24) {
            return hourDiff == 1 ? hourDiff + ' hour ago' : hourDiff + ' hours ago';
        } else if (dayDiff < 30) {
            return dayDiff == 1 ? dayDiff + ' day ago' : dayDiff + ' days ago';
        } else if(monthDiff < 12) {
            return monthDiff == 1 ? monthDiff + ' month ago' : monthDiff + ' months ago';  
        } else {
            return yearDiff == 1 ? yearDiff + ' year ago' : yearDiff + ' years ago'; 
        }
        return 'now';
    },

    loadImage: (image) => {
        return image == '' || image == undefined ? "assets/img/default.png" : image;
    },

    downloadBase64File: (base64Data, fileName) => {
        if(base64Data != '' && base64Data != undefined)
        {
            const downloadLink = document.createElement("a");
            downloadLink.href = base64Data;
            downloadLink.download = fileName;
            downloadLink.click();
        }
    },

    getErrorMessages: (errorMessages) => {
            if(errorMessages.length === 1)
            {
                return errorMessages[0];
            }
            var messageToReturn = '';
            var index = 1;
            errorMessages.forEach(element => {
                messageToReturn = messageToReturn + index.toString() + ': ' + element + "<br />";
                index++;
            });

            return messageToReturn;
    },

    getRandomNumber: () => {
        return Math.floor(Math.random() * 100000000);
    },

    getTimeAMPM: (date) => {
        if(date == undefined) {
            date = new Date();
        }
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+ minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }
}

export default Util